// 원장 호출 — 데스크 띠 (치과 웹 맨 위, 접수 화면 밖 페이지에서만). 명세 §1·§3
//  - 평소 = 6px 회색 줄(연결 살아 있음). 연결 끊김 = 얇은 회색 글자 줄
//  - 미응답 deskShowSec 이상 = 펼침: "3번 체어 · 마취 완료 · 원장 미응답 1:05 외 N건" + [원장실로 전화](기록만) · [방문객 있음]
//  - 원장이 응답하면 자동 접힘. 데스크는 호출을 만들거나 끄지 못한다
//  - 게이트(치과·doctorCall 플래그·경로)는 MainLayout 이 한다. 이 컴포넌트를 그리면 구독이 시작된다
import React from 'react';
import { useDoctorCall } from './useDoctorCall';
import { DeskButtons, overdueText } from './DoctorCallParts';
import { situationColor } from '../../../utils/doctorCall';

function DoctorCallDeskStrip({ clinicId }) {
    const dc = useDoctorCall(clinicId, true);
    const overdue = dc.deskOverdue;

    if (overdue.length > 0) {
        const urgent = overdue.some(c => c.situation === 'urgent');
        const uc = situationColor('urgent', dc.settings);   // 설정의 급함 색(빨강/진한 주황)
        return (
            <div className="no-print" role="alert" style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', minHeight: 44, background: urgent ? '#fff7f5' : '#fffbeb', border: `${urgent ? 2 : 1}px solid ${urgent ? uc : '#f59e0b'}`, borderRadius: 8, padding: '8px 14px', margin: '0 0 12px' }}>
                <span style={{ fontSize: 14, fontWeight: 800, color: urgent ? uc : '#92400e', flex: '1 1 260px', minWidth: 0 }}>
                    {`원장 호출 — ${overdueText(overdue, dc.settings, dc.nowMs)}`}
                </span>
                {!dc.connected && <span style={{ fontSize: 12, color: '#4b5563' }}>{'연결 끊김'}</span>}
                <DeskButtons overdue={overdue} dc={dc} />
            </div>
        );
    }
    if (dc.loaded && !dc.connected) {
        return (
            <div className="no-print" role="status" style={{ background: '#e5e7eb', color: '#4b5563', fontSize: 12, fontWeight: 600, borderRadius: 4, padding: '2px 10px', margin: '0 0 10px' }}>
                {dc.err ? `원장 호출 — ${dc.err}` : '원장 호출 연결 끊김 — 다시 연결되면 자동으로 이어집니다'}
            </div>
        );
    }
    // 연결 살아 있음 — 6px 회색 줄
    return <div className="no-print" title="원장 호출 연결됨" aria-hidden="true" style={{ height: 6, background: '#d1d5db', borderRadius: 3, margin: '0 0 10px', opacity: dc.connected ? 1 : 0.4 }} />;
}

export default DoctorCallDeskStrip;
